(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('net-footer-accordions')) {
    customElements.define('net-footer-accordions', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const mobile = window.matchMedia('(max-width: 749px)');
        const columns = this.querySelectorAll('.net-footer-accordion');
        const sync = () => columns.forEach(column => {
          column.open = !mobile.matches;
          const summary = column.querySelector('summary');
          if (mobile.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
        this.addEventListener('click', event => {
          if (!mobile.matches && event.target.closest('summary')) event.preventDefault();
        }, options);
        mobile.addEventListener('change', sync, options);
        sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-offers"] && !Shopify.designMode) return;
  try {
    
  function showNewsletterResult() {
    const url = new URL(window.location.href);
    document.querySelectorAll('.net-newsletter__form').forEach(form => {
      const dialog = form.closest('.net-newsletter').querySelector('[data-newsletter-dialog]');
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      const message = form.querySelector('[data-newsletter-success]');
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
        const button = form.querySelector('[type="submit"]');
        const error = form.querySelector('[data-newsletter-request-error]');
        const defaultError = error.textContent;
        error.hidden = true;
        form.querySelector('[data-newsletter-error]')?.remove();
        form.dataset.submitting = 'true';
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          const data = new FormData(form);
          const returnUrl = new URL(window.location.href);
          returnUrl.hash = '';
          returnUrl.searchParams.set('customer_posted', 'true');
          returnUrl.searchParams.set('newsletter', 'offers');
          data.set('return_to', returnUrl.pathname + returnUrl.search);
          const response = await fetch(form.action, {
            method: 'POST',
            body: data,
            credentials: 'same-origin'
          });
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const returnedForm = html.getElementById(form.id);
          const errors = returnedForm?.querySelector('[data-newsletter-error]');
          const success = returnedForm?.querySelector('[data-newsletter-success]');
          const responseUrl = new URL(response.url);
          const confirmed = responseUrl.searchParams.get('customer_posted') === 'true';
          if (!response.ok || errors || (!confirmed && (!success || success.hidden)) || responseUrl.pathname.includes('/challenge')) {
            throw new Error(errors?.textContent?.trim() || defaultError);
          }
          message.hidden = false;
          form.querySelector('[data-newsletter-inputs]').hidden = true;
          if (!dialog.open) dialog.showModal();
        } catch (failure) {
          error.textContent = failure.message === 'Failed to fetch' ? defaultError : failure.message || defaultError;
          error.hidden = false;
        } finally {
          form.dataset.submitting = 'false';
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
      const returned = url.searchParams.get('customer_posted') === 'true'
        && (url.searchParams.get('newsletter') === 'offers' || url.hash === `#${form.id}` || url.hash === '#contact_form');
      if (form.querySelector('[data-newsletter-error]') || !message || (message.hidden && !returned)) return;
      message.hidden = false;
      form.querySelector('[data-newsletter-inputs]').hidden = true;
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('newsletter');
      if (url.hash === `#${form.id}` || url.hash === '#contact_form') url.hash = '';
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      dialog.showModal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showNewsletterResult, { once: true });
  else showNewsletterResult();
  document.addEventListener('shopify:section:load', showNewsletterResult);

  } catch(e) { console.error(e); }
})();
})();
